import React, { Component } from 'react';
import { Link, Redirect, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import * as Sentry from '@sentry/browser';

import { addReview, checkReview } from './actions';
import starGray from '../../assets/images/star-gray.svg';
import starYellow from '../../assets/images/star-yellow.svg';
import getFormattedMobileNumber from '../../helpers/getFormattedMobileNumber';
import './index.css';
import { ReactComponent as BlackLoading } from '../../assets/images/black-loading-icon.svg';
import { selectStoreConfig } from '../Layout/selectors';

class Reviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 0,
      delay: false,
      rows: 2,
      keyBoard: false,
      firstName: '',
      comment: '',
      showFirstNameScreen: false,
    };
  }

  componentDidMount() {
    let data = this.props.history.location.pathname.split('/');
    if (data.length === 4) {
      this.props.checkReviewHandler(data[3], data[2]);
    } else {
      this.props.history.replace('/');
    }
    window.navigator.userAgent.match(/android/i) &&
      window.addEventListener(
        'resize',
        this.onElementHeightChange.bind(this, window.innerHeight)
      );
  }

  componentDidUpdate() {
    if (this.props.review.submited) {
      this.props.history.replace('/');
    }
  }

  componentWillUnmount() {
    window.navigator.userAgent.match(/android/i) &&
      window.removeEventListener(
        'resize',
        this.onElementHeightChange.bind(this)
      );
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  handleAnimation = (index) => {
    const minReviewForGoogle =
      Number(this.props.review.orderSetup?.minReviewForGoogle) || 5;
    if (
      this.props?.review?.orderSetup?.isEnableGoogleReview &&
      Number(minReviewForGoogle) <= index &&
      this.props?.review?.orderSetup?.googleReviewLink?.length > 0
    ) {
      window.open(
        this.props.review.orderSetup.googleReviewLink,
        '_blank',
        'noopener,noreferrer'
      );
      this.props.history.push('/');
    } else {
      if (
        (this.state.rating === 2 ||
          this.state.rating === 3 ||
          this.state.rating === 4 ||
          this.state.rating === 5) &&
        (index === 2 || index === 3 || index === 4 || index === 5)
      ) {
        this.setState({
          delay: true,
          rating:
            this.state.rating === index ? this.state.rating - 1 : Number(index),
        });
      } else {
        this.setState({
          delay: false,
          rating:
            this.state.rating === index ? this.state.rating - 1 : Number(index),
        });
      }
    }
  };

  manageTextArea = () => {
    if (this.state.rows < 8) {
      if (this.node.value.length === 0) {
        this.setState({ rows: 2 });
      } else if (window.navigator.userAgent.match(/android/i)) {
        if (this.node.scrollHeight > 50 && this.node.scrollHeight <= 75) {
          this.setState({ rows: 3 });
        } else if (
          this.node.scrollHeight > 75 &&
          this.node.scrollHeight <= 100
        ) {
          this.setState({ rows: 4 });
        } else if (
          this.node.scrollHeight > 100 &&
          this.node.scrollHeight <= 125
        ) {
          this.setState({ rows: 5 });
        } else if (
          this.node.scrollHeight > 125 &&
          this.node.scrollHeight <= 150
        ) {
          this.setState({ rows: 6 });
        } else if (
          this.node.scrollHeight > 150 &&
          this.node.scrollHeight <= 175
        ) {
          this.setState({ rows: 7 });
        }
      } else {
        if (this.node.scrollHeight > 52 && this.node.scrollHeight <= 78) {
          this.setState({ rows: 3 });
        } else if (
          this.node.scrollHeight > 78 &&
          this.node.scrollHeight <= 104
        ) {
          this.setState({ rows: 4 });
        } else if (
          this.node.scrollHeight > 104 &&
          this.node.scrollHeight <= 130
        ) {
          this.setState({ rows: 5 });
        } else if (
          this.node.scrollHeight > 130 &&
          this.node.scrollHeight <= 156
        ) {
          this.setState({ rows: 6 });
        } else if (
          this.node.scrollHeight > 156 &&
          this.node.scrollHeight <= 182
        ) {
          this.setState({ rows: 7 });
        }
      }
    }
  };

  handleTextArea = (e) => {
    this.setState({
      comment: e.target.value,
    });
  };

  onElementHeightChange = (height) => {
    let lastHeight = height;
    let newHeight = window.innerHeight;
    if (lastHeight - newHeight > 125) {
      this.setState({ keyBoard: true });
    } else {
      if (this.state.keyBoard === true && lastHeight - newHeight === 0) {
        this.setState({ keyBoard: false });
      }
    }
  };

  handleFirstName = (e) => {
    this.setState({
      firstName: e.target.value,
    });
  };

  submit = () => {
    const { storeConfig } = this.props;
    let nowDate = new Date();
    let data = this.props.history.location.pathname.split('/');
    if (
      this.state.rating > 0 &&
      data.length === 4 &&
      this.props.review.orderReview
    ) {
      const review = {
        userId: this.props.review.orderReview.userId
          ? this.props.review.orderReview.userId
          : '',
        rating: this.state.rating,
        comment: this.state.comment,
        firstName: this.props.review.orderReview.firstName
          ? this.props.review.orderReview.firstName
          : '',
        lastName: this.props.review.orderReview.lastName
          ? this.props.review.orderReview.lastName
          : '',
        mobileNumber: this.props.review.orderReview.mobileNumber
          ? getFormattedMobileNumber(this.props.review.orderReview.mobileNumber)
          : '',
        userName:
          this.props.review.orderReview.firstName &&
          this.props.review.orderReview.lastName
            ? `${this.props.review.orderReview.firstName} ${this.props.review.orderReview.lastName}`
            : '',
        reviewType: this.props.review.orderReview.orderType,
        storeId: this.props.review.orderReview.storeId
          ? this.props.review.orderReview.storeId
          : '',
        restaurantId: this.props.review.orderReview.restaurantId
          ? this.props.review.orderReview.restaurantId
          : '',
        orderId: data[3],
        isVisible: true,
        date: moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
        dateTimestamp: nowDate.getTime(),
      };
      // OrderType=4 means other deliveries
      if (
        this.props.review &&
        this.props.review.orderReview &&
        this.props.review.orderReview.orderType === 4 &&
        !this.props.review.orderReview.firstName
      ) {
        review.firstName = this.state.firstName;
        review.userName = this.state.firstName;
      }
      this.props.addReviewHandler(review);
      this.props.history.replace('/category/popular');
    }
  };

  updateFirstNameFlag = (flag) => {
    this.setState({
      showFirstNameScreen: flag,
    });
  };

  renderFirstNameScreen = () => {
    let firstNameClass = classNames({
      'reviewsStar col-xs-12': true,
      'reservation-animation': this.state.showFirstNameScreen === true,
      // 'reverse-reservation-animation': this.state.showAnimation === true,
    });

    let finalSubmitClass = classNames({
      nextDetails: this.state.firstName !== '',
      'nextDetails disabled': !(this.state.firstName !== ''),
    });
    return (
      <div className={firstNameClass}>
        <div
          className='detailsTitle visible-xs visible-sm'
          style={{
            paddingRight: '0px',
            fontVariantLigatures: 'no-common-ligatures',
          }}
        >
          What’s your first name?
        </div>
        <div
          className='inputGroup'
          style={{
            position: 'absolute',
            top: '50%',
            width: 'calc(100% - 40px)',
            left: '20px',
            transform: 'translateY(-50%)',
          }}
        >
          <span>First name</span>
          <input
            type='text'
            name='firstName'
            value={this.state.firstName}
            onChange={this.handleFirstName}
          />
        </div>
        <div className={finalSubmitClass} onClick={this.submit}>
          Submit
        </div>
      </div>
    );
  };

  render() {
    let submitClass = classNames('submitReview', {
      nextDetails:
        this.state.rating > 0 &&
        this.props.history.location.pathname.split('/')[2] !== undefined &&
        this.props.review.orderReview,
      'nextDetails disabled': !(
        this.state.rating > 0 &&
        this.props.history.location.pathname.split('/')[2] !== undefined &&
        this.props.review.orderReview
      ),
    });
    if (!this.props.review.orderSetup) {
      return (
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <BlackLoading height='50px' width='50px' />
        </div>
      );
    }
    return window.innerWidth < 992 ? (
      <React.Fragment>
        {this.state.showFirstNameScreen ? (
          <React.Fragment>
            <div className='animation-wrapper'>
              {this.renderFirstNameScreen()}
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div
              className={
                this.state.keyBoard
                  ? `reviewsStar col-xs-12 keyB row${this.state.rows}`
                  : 'reviewsStar col-xs-12'
              }
            >
              <Link to='/' replace className='closeIt'>
                <div className='visible-xs close-x thickcon-X'>Close</div>
              </Link>
              <div className='detailsTitle'>How was your last experience?</div>
              <div className='stars'>
                <div className='starInner'>
                  <div
                    className={
                      Number(this.state.rating) >= 1
                        ? Number(this.state.rating) > 1
                          ? 'star active'
                          : 'star active'
                        : 'star'
                    }
                    onClick={() => this.handleAnimation(1)}
                  >
                    <img src={starGray} alt='' />
                    <img className='yellow' src={starYellow} alt='' />
                  </div>
                </div>
                <div className='starInner'>
                  <div
                    className={
                      Number(this.state.rating) >= 2 ? 'star active' : 'star'
                    }
                    onClick={() => this.handleAnimation(2)}
                  >
                    <img src={starGray} alt='' />
                    <img className='yellow' src={starYellow} alt='' />
                  </div>
                </div>
                <div
                  className={
                    this.state.delay ? 'starInner active3' : 'starInner'
                  }
                >
                  <div
                    className={
                      Number(this.state.rating) >= 3 ? 'star active' : 'star'
                    }
                    onClick={() => this.handleAnimation(3)}
                  >
                    <img src={starGray} alt='' />
                    <img className='yellow' src={starYellow} alt='' />
                  </div>
                </div>
                <div
                  className={
                    this.state.delay ? 'starInner active4' : 'starInner'
                  }
                >
                  <div
                    className={
                      Number(this.state.rating) >= 4 ? 'star active' : 'star'
                    }
                    onClick={() => this.handleAnimation(4)}
                  >
                    <img src={starGray} alt='' />
                    <img className='yellow' src={starYellow} alt='' />
                  </div>
                </div>
                <div
                  className={
                    this.state.delay ? 'starInner active5' : 'starInner'
                  }
                >
                  <div
                    className={
                      Number(this.state.rating) >= 5 ? 'star active' : 'star'
                    }
                    onClick={() => this.handleAnimation(5)}
                  >
                    <img src={starGray} alt='' />
                    <img className='yellow' src={starYellow} alt='' />
                  </div>
                </div>
              </div>
              <div
                className={this.state.rating > 0 ? 'inputRs active' : 'inputRs'}
              >
                <textarea
                  ref={(ref) => (this.node = ref)}
                  placeholder='Leave a comment...'
                  rows={this.state.rows}
                  onKeyUp={(e) => this.manageTextArea(e)}
                  onChange={this.handleTextArea}
                  value={this.state.comment}
                />
              </div>
              {this.props?.review?.orderReview?.orderType === 4 ? (
                <div
                  className={submitClass}
                  onClick={() => this.updateFirstNameFlag(true)}
                >
                  Submit
                </div>
              ) : (
                <div className={submitClass} onClick={this.submit}>
                  Submit
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    ) : (
      <Redirect to='/' />
    );
  }
}

function mapStateToProps(state) {
  return {
    review: state.reviewReducer,
    storeConfig: selectStoreConfig(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addReviewHandler: (review, pagination) =>
      dispatch(addReview(review, pagination)),
    checkReviewHandler: (orderId, orderType) =>
      dispatch(checkReview(orderId, orderType)),
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Reviews)
);
